import { ChangeEvent } from "react";

import { Specimen } from "pwapi";

import { selectFeatureFlag } from "shared/reducers/sysReducer";
import { procedureEnumToLabel } from "shared/utils/specimenUtils";

import DateRangeInput from "components/customInputs/DateRangeInput";
import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";
import { useAppSelector } from "store/hooks";

type SpecimenFiltersProps = {
  specimensBiopsyType: string;
  specimensProcedure: string;
  specimensType: string;
  specimensSource: string;
  specimensSite: string;
  grossCompletedAfter: string;
  grossCompletedBefore: string;

  onChange: Function;
  onChangeDateRange: Function;
};

const SpecimenFilters = (props: SpecimenFiltersProps) => {
  const adminWPLFilters = useAppSelector((state) =>
    selectFeatureFlag(state, "adminWPLFilters")
  );
  return (
    <>
      {adminWPLFilters && (
        <>
          <DateRangeInput
            id="grossCompleted"
            label="WPL Gross Date"
            values={{
              from: {
                id: "grossCompletedAfter",
                name: "gross_completed_after",
                value: props.grossCompletedAfter,
              },
              to: {
                id: "grossCompletedBefore",
                name: "gross_completed_before",
                value: props.grossCompletedBefore,
              },
            }}
            onChangeDate={props.onChangeDateRange}
            isClearable
          />
          <TextInput
            id="specimensSource"
            value={props.specimensSource}
            label="WPL Specimen Source"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              props.onChange("specimensSource", e.target.value || "")
            }
            onClear={() => props.onChange("specimensSource", "")}
          />
          <SelectInput
            id="specimensBiopsyType"
            label="WPL Specimen Biopsy Type"
            defaultLabel="All Types"
            options={Object.values(Specimen.biopsy_type).map((v) => ({
              label: v,
              value: v,
            }))}
            value={props.specimensBiopsyType}
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              props.onChange("specimensBiopsyType", e.target.value || "")
            }
          />
        </>
      )}
      <SelectInput
        id="specimensType"
        label="Specimen Type"
        defaultLabel="All Types"
        options={Object.values(Specimen.type).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.specimensType}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensType", e.target.value || "")
        }
      />
      <TextInput
        id="specimensSite"
        value={props.specimensSite}
        label="Specimen Site"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          props.onChange("specimensSite", e.target.value || "")
        }
        onClear={() => props.onChange("specimensSite", "")}
      />
      <SelectInput
        id="specimenProcedure"
        label="Specimen Procedure"
        defaultLabel="All Procedures"
        options={Object.values(Specimen.procedure).map((v) => ({
          label: procedureEnumToLabel(v) || "",
          value: v,
        }))}
        value={props.specimensProcedure}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensProcedure", e.target.value || "")
        }
      />
    </>
  );
};

export default SpecimenFilters;
